function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportMobile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.961 13.9336C21.361 14.1403 22.341 15.3736 22.341 18.0736V18.1603C22.341 21.1403 21.1476 22.3336 18.1676 22.3336H13.8276C10.8476 22.3336 9.6543 21.1403 9.6543 18.1603V18.0736C9.6543 15.3936 10.621 14.1603 12.981 13.9403",
    stroke: "#0D192C",
    style: {
      stroke: "#0D192C",
      stroke: "color(display-p3 0.0510 0.0980 0.1725)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 17.9998V10.4131",
    stroke: "#0D192C",
    style: {
      stroke: "#0D192C",
      stroke: "color(display-p3 0.0510 0.0980 0.1725)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2342 11.9003L16.0009 9.66699L13.7676 11.9003",
    stroke: "#0D192C",
    style: {
      stroke: "#0D192C",
      stroke: "color(display-p3 0.0510 0.0980 0.1725)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportMobile);
export default __webpack_public_path__ + "static/media/exportMobile.6a8b1396cdcb326196a609386fc1ceb8.svg";
export { ForwardRef as ReactComponent };